import React from 'react';
import {
    GroupPanel,
    Grouping
} from 'devextreme-react/data-grid';

import { TCommonProps, TForwardedRef } from 'types/gridDefs';

import { DataGridBase } from './DataGrid/DataGrid.Base';
import { ErrorBoundary } from './Error/ErrorBoundary';
import * as groupHelpers from './helpers/groupHelpers';

/* ======================================== */

type TProps = TCommonProps;

/* ======================================== */

/**
 * Standard adserve DataGrid with collapsible groups
 * !! prototype: still under development !!
 * @public
 */
export const AsDataGridGroup = React.forwardRef<TForwardedRef, TProps>((props, forwardedRef) => {
    return (
        <ErrorBoundary name='AsDataGridGroup'>
            <DataGridBase
                {...props}
                ref={forwardedRef}
            >
                <Grouping
                    allowCollapsing={true}
                    contextMenuEnabled={false}
                    expandMode='buttonClick'
                    texts={groupHelpers.groupingTexts}
                />
                <GroupPanel
                    visible={false}
                    allowColumnDragging={false}
                    emptyPanelText=''
                />
            </DataGridBase>
        </ErrorBoundary>
    );
});
